<template>
    <div class="blueBg">
        <div class="inner">
            <h3>{{ $t('menu.bonusTerms') }}</h3>

            <div class="textBox">
                <!-- article - 1 -->
                <p class="mt-0 font-weight-bold">{{ $t('bonus.article1.title') }}</p>
                <p>{{ $t('bonus.article1.text') }}</p>

                <!-- article - 2 -->
                <p class="mt-4 font-weight-bold">{{ $t('bonus.article2.title') }}</p>
                <p>{{ $t('bonus.article2.text') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article2.point1') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article2.point2') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article2.point3') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article2.point4') }}</p>

                <!-- article - 3 -->
                <p class="mt-4 font-weight-bold">{{ $t('bonus.article3.title') }}</p>
                <p>{{ $t('bonus.article3.text') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article3.point1') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article3.point2') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article3.point3') }}</p>

                <!-- article - 4 -->
                <p class="mt-4 font-weight-bold">{{ $t('bonus.article4.title') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article4.point1') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article4.point2') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article4.point3') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article4.point4') }}</p>

                <!-- article - 5 -->
                <p class="mt-4 font-weight-bold">{{ $t('bonus.article5.title') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article5.point1') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article5.point2') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article5.point3') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article5.point4') }}</p>

                <!-- article - 6 -->
                <p class="mt-4 font-weight-bold">{{ $t('bonus.article6.title') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article6.point1') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article6.point2') }}</p>

                <!-- article - 7 -->
                <p class="mt-4 font-weight-bold">{{ $t('bonus.article7.title') }}</p>
                <p>{{ $t('bonus.article7.text') }}</p>

                <!-- article - 8 -->
                <p class="mt-4 font-weight-bold">{{ $t('bonus.article8.title') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article8.point1') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article8.point2') }}</p>

                <div class="text-center">
                    <table id="bonus-terms-table">
                        <tr>
                            <th>{{ $t('bonus.article8.rank') }}</th>
                            <th>{{ $t('bonus.article8.bonus1') }}</th>
                            <th>{{ $t('bonus.article8.bonus2') }}</th>
                            <th>{{ $t('bonus.article8.bonus3') }}</th>
                            <th colspan="2">{{ $t('bonus.article8.bonus4') }}</th>
                        </tr>
                        <tr>
                            <td>{{ $t('bonus.article8.rank8') }}</td>
                            <td rowspan="8">{{ $t('bonus.article8.percentage1') }}</td>
                            <td rowspan="7">{{ $t('bonus.article8.percentage2') }}</td>
                            <td rowspan="6">{{ $t('bonus.article8.percentage3') }}</td>
                            <td rowspan="5">{{ $t('bonus.article8.percentage4') }}</td>
                            <td>{{ $t('bonus.article8.reward1') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('bonus.article8.rank7') }}</td>
                            <td>{{ $t('bonus.article8.reward2') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('bonus.article8.rank6') }}</td>
                            <td>{{ $t('bonus.article8.reward3') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('bonus.article8.rank5') }}</td>
                            <td>{{ $t('bonus.article8.reward4') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('bonus.article8.rank4') }}</td>
                            <td>{{ $t('bonus.article8.reward5') }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('bonus.article8.rank3') }}</td>
                            <td class="no-bonus"></td>
                            <td class="no-bonus"></td>
                        </tr>
                        <tr>
                            <td>{{ $t('bonus.article8.rank2') }}</td>
                            <td class="no-bonus"></td>
                            <td class="no-bonus"></td>
                            <td class="no-bonus"></td>
                        </tr>
                        <tr>
                            <td>{{ $t('bonus.article8.rank1') }}</td>
                            <td class="no-bonus"></td>
                            <td class="no-bonus"></td>
                            <td class="no-bonus"></td>
                            <td class="no-bonus"></td>
                        </tr>
                    </table>
                </div>

                <p class="p-0 pl-4 num">{{ $t('bonus.article8.point3') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article8.point4') }}</p>
                <p class="p-0 pl-4 num">{{ $t('bonus.article8.point5') }}</p>
                <p class="p-0 pl-4 num" v-html="$t('bonus.article8.point6')"></p>

                <!-- enactment date -->
                <p class="mt-5">
                    {{ $t('bonus.enactment_date', {
                        y: 2020,
                        m: 8,
                        M: 'August',
                        d: 31,
                    }) }}
                </p>
                <p>
                    {{ $t('bonus.revision_date', {
                        y: 2025,
                        m: 10,
                        M: 'October',
                        d: 1,
                    }) }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'bonusTerms',

        components: {
        },

        mounted() {
        }
    }
</script>

<style scoped>
    @media only screen and (max-width: 991px) {
        .pl-4, .px-4 {
            padding-left: 1rem !important;
        }
    }
    #bonus-terms-table {
        margin: 20px auto 10px;
    }
    #bonus-terms-table th, #bonus-terms-table td {
        border: 1px solid #535353;
        text-align: center;
        vertical-align: middle;
        padding: 5px;
    }
    #bonus-terms-table th {
        font-weight: normal;
    }
    .no-bonus {
        background-color: #c0c0c0;
    }
</style>
